export default __webpack_public_path__ + "static/media/mobilepay.bd6dba34.svg";